module.exports = __webpack_public_path__ + "static/media/corpoHomem.932f1942.png";